module.exports = __webpack_public_path__ + "img/action-share.c1101c35.svg";